import { Injectable } from '@angular/core';
import { Constants } from '../constants/constants';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  
  constructor(private env: EnvService) { }

  getDeviceLogo(device): string {
    var logo;
    // logo = "assets/images/car-placeholder.png";
    // var image = device.logo;
    if (device && device.telematicsProvider && device.telematicsProvider == "CONTINENTAL") {
      // image = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfmqrn4n7XoU12ssTV3N6vlYoy2uNgs2n7ZzNP0GNx4YRB8QOQDE_7TeXpY-hrCdEGFhc&usqp=CAU';
      logo = 'assets/images/continental.jpg';
    }
    /* if (!image || image == this.env.BASE_URL + "assets/images/1615468052551-nissan.png") {
      if (device.make.toUpperCase() == "NISSAN") {
        logo = "assets/images/logo/nissan-next-logo-black.png"
      } else if (device.make.toUpperCase() == "INFINITI") {
        logo = "assets/images/infiniti-logo-dark.png"
      }
    } else {
      logo = image;
    } */
    return logo;
  }

}
